













import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.specificities.industrial.coveredBaysCount",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["INDUSTRY"].indexOf(this.getPropertyType()) !== - 1;
        },
        amountCoveredBays: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
    },
    mounted: function() {
        if (this.isDisplayed && this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: 0});
        }
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(amountCoveredBays: number): void {
            if (amountCoveredBays === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": amountCoveredBays});
            }
        }
    },
});

